import { render } from "./customerOrder.vue?vue&type=template&id=39a6d01c&scoped=true"
import script from "./customerOrder.vue?vue&type=script&lang=js"
export * from "./customerOrder.vue?vue&type=script&lang=js"

import "./customerOrder.vue?vue&type=style&index=0&id=39a6d01c&lang=less&scoped=true"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a6d01c"]])

export default __exports__